import React, { Suspense } from 'react'
import { renderRoutes } from 'react-router-config'

type MerchantProps = {
  route: any
}

const Merchant = ({ ...props }: MerchantProps) => {

  return (
    <Suspense fallback={<></>}>
      {renderRoutes(props.route.routes)}
    </Suspense>
  )
}


export default Merchant
